import { call, put } from 'redux-saga/effects';
import { sendError } from '../../../';
import { userData, userError, UserFetch } from '../actions';
import api from '../../../../api-new/http';
import { appUrls } from '../../../../api-new/urls';

export function* userSaga(action: UserFetch) {
    try {
        const token = localStorage.getItem('csrfToken');

        if (!token) {
            throw new Error('Token not found');
        }

        const response = yield call(() =>
            api.get(`${appUrls.authenURL}/profile`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            }),
        );
        
        yield put(userData({ user: response.data.data }));
    } catch (error: any) {
        const errorSetup = {
            message: error.response.data.errors[0].errorMessage,
            code: error.response.status,
            codeConfig: error.response.data.errors[0].errorCode,
        };
        yield put(
            sendError({
                error: errorSetup,
                processingType: 'alert',
                extraOptions: {
                    actionError: userError,
                },
            }),
        );
    }
}
